const { useState, useEffect } = wp.element;

import DayJS from 'dayjs';
import { Line } from 'react-chartjs-2';

import Error from './error';
import { numberWithCommas } from './helpers';
import { getUsersSessionsViews } from './analytics';


const Historical = (props) => {
  const [ viewId, setViewId ] = useState();
  const [ fromDate, setFromDate ] = useState(DayJS().subtract(1, 'week'));
  const [ error, setError ] = useState();
  const [ visible, setVisible ] = useState();
  const [ analyticsData, setAnalyticsData ] = useState();

  const refresh = async () => {
    try {
      if (viewId && fromDate) {
        props.onUpdate?.();
        setAnalyticsData(await getUsersSessionsViews(viewId, fromDate));
      }
    }
    catch (err) {
      setError(err);
    }
    finally {
      props.onUpdated?.();
    }
  };

  const chartOptions = {
    legend: { position: 'bottom' },
    scales: {
      yAxes: [{ ticks: { callback: (value) => numberWithCommas(value) } }]
    },
    tooltips: {
      callbacks: { label: (item) => ' ' + numberWithCommas(item.value) }
    }
  };

  useEffect(() => { refresh() }, [ viewId, fromDate ]);
  useEffect(() => setViewId(props.viewId), [ props.viewId ]);
  useEffect(() => setVisible(props.visible), [ props.visible ]);

  const FromDateLink = (props) => {
    const { value, unit, label } = props;
    const newFromDate = DayJS().subtract(value, unit);
    const onClick = () => setFromDate(newFromDate);
    if ( fromDate.format('YYYYMMDD') === newFromDate.format('YYYYMMDD'))
      return (<span>{label}</span>);
    return (<a onClick={onClick} href="#" style={{ textDecoration: 'none' }}>{label}</a>);
  }

	return visible ? (
    <div class='meow-analytics-dashboard-block'>

      {/* Menu */}
      <div style={{ marginBottom: '10px' }}>
        <FromDateLink value='24' unit='hour' label='24 hours' /> |&nbsp;
        <FromDateLink value='1' unit='week' label='1 week' /> |&nbsp;
        <FromDateLink value='1' unit='month' label='1 month' /> |&nbsp;
        <FromDateLink value='6' unit='month' label='6 month' /> |&nbsp;
        <FromDateLink value='1' unit='year' label='1 year' /> |&nbsp;
        <FromDateLink value='10' unit='years' label='10 years' />
      </div>

      {/* Display errors */}
      <Error error={error} reset={() => setError()} />

      {/* Display chart */}
      {!error && analyticsData &&
        <Line data={analyticsData} options={chartOptions} />
      }

    </div>
  ) : null;
}

export default Historical;